import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { showModal, hideModal } from 'appSrc/redux/actions';
import { dAPI } from 'appSrc/api';
import { Icon, Table, DLMenu } from 'appSrc/components/UI';
import { CopyDrop } from '../../Common';
import ListCoverImage from 'appSrc/components/List/CoverImage';
import EditListModal from '../../Modals/List/EditListModal';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class FeaturedListsTable extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            listInEdit: null,
            listInEditIndex: -1,
        };
    }
    updateList =( index, listid, data ) => {
        this.props.updateList( listid, data )
        .then( ( list ) => {
            return this.props.onListUpdated && this.props.onListUpdated( index, list );
        } );
    }
    openEditModal = ( index, list ) => {
        this.setState( { listInEdit: list, listInEditIndex: index } );
        this.props.showModal( 'editListModal' );
    }
    onEditSubmit = ( updates ) => {
        var index = this.state.listInEditIndex;
        var oldList = this.state.listInEdit;
        var calls = [];
        for( var i = 0; i < updates.tags.newTags.length; i++ ) {
            var tag = updates.tags.newTags[ i ];
            calls.push( this.props.addTagToList( oldList.listid, tag.tagtext ) );
        }
        for( var j = 0; j < updates.tags.deletedTags.length; j++ ) {
            var dTag = updates.tags.deletedTags[ j ];
            calls.push( this.props.deleteTagFromList( oldList.listid, dTag.tagtext ) );
        }
        return Promise.all( calls )
        .then( () => {
            return this.props.updateList( oldList.listid, updates.list );
        } )
        .then( ( updatedList ) => {
            this.props.onListUpdated( index, updatedList );
            return updatedList;
        } );
    }
    onEditDelete = () => {
        var index = this.state.listInEditIndex;
        var oldList = this.state.listInEdit;
        return this.props.deleteList( oldList.listid )
        .then(() => {
            this.props.onListDeleted( index, oldList );
            return oldList;
        });
    }
    onEditClose = () => {
        this.props.hideModal( 'editListModal' );
        this.setState( { listInEdit: null, listInEditIndex: -1 } );
    }

    render() {
        const { lists } = this.props;

        return (
            <div>
                <Table
                className={ style.listsTable }
                loadMore={ this.props.loadMore }
                elementHeight={ 70 }>
                    <Table.Head>
                        <Table.Row draggable={ false }>
                            <Table.Cell></Table.Cell>
                            <Table.Cell style={ { minWidth: '100px' } }></Table.Cell>
                            <Table.Cell>LIST NAME</Table.Cell>
                            <Table.Cell>USER</Table.Cell>
                            <Table.Cell>CATEGORY</Table.Cell>
                            <Table.Cell>PRODUCTS</Table.Cell>
                            <Table.Cell></Table.Cell>
                            <Table.Cell>ACTIONS</Table.Cell>
                        </Table.Row>
                    </Table.Head>
                    <Table.SortableBody onChange={ this.props.onSort }>
                        { this.arrayTableRows( lists ) }
                    </Table.SortableBody>
                </Table>
                { this.state.listInEdit &&
                    <EditListModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    onDelete={ this.onEditDelete }
                    list={ this.state.listInEdit } />
                }
            </div>
        );
    }

    arrayTableRows = ( lists ) => {
        var rows = lists.map( ( list, index ) => {
            var author = list.author || {};
            var individualSlug = `/admin/lists/${ list.listid }`;
            var publicSlug = `${ window.location.origin }/${ author.slug }/${ list.slug }`;
            return (
                <Table.Row key={ list.listid }>
                    <Table.Cell className='handle' style={ { cursor: 'grab' } }>
                        <Icon source='fontAwesome' icon='fas/faArrowsAltV' style={ { color: 'inheirit' } } />
                    </Table.Cell>
                    <Table.Cell className={ style.coverImage }>
                        <Link to={ individualSlug }></Link>
                        <ListCoverImage videoId={ list.youtube } coverImage={ list.coverImage } />
                    </Table.Cell>
                    <Table.Cell>
                        <Link to={ individualSlug }></Link>
                        { list.title }
                    </Table.Cell>
                    <Table.Cell>
                        <Link to={ `/${ author.slug }/${ list.slug }` }></Link>
                        { author.displayName }
                    </Table.Cell>
                    <Table.Cell>
                        <Link to={ individualSlug }></Link>
                        { list.categories.map( category => category.name ).join( ', ' ) }
                    </Table.Cell>
                    <Table.Cell className={ style.actionsCell }>
                        <Link to={ individualSlug }></Link>
                        { list.desires.length }
                    </Table.Cell>
                    <Table.Cell className={ style.actionsCell }>
                        <CopyDrop content={ publicSlug } />
                    </Table.Cell>
                    <Table.Cell className={ style.actionsCell }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Edit'
                            onClick={ () => {
                                this.openEditModal( index, list );
                            } }/>
                            <DLMenu.Item text={ !list.published ? 'Publish' : 'Unpublish' }
                            onClick={ () => {
                                this.updateList( index, list.listid, {
                                    published: !list.published,
                                    title: list.title,
                                } );
                            } }/>
                            <DLMenu.Item text={ list.featured ? 'Unfeature' : 'Feature' }
                            onClick={ () => {
                                this.updateList( index, list.listid, {
                                    featured: !list.featured,
                                    title: list.title,
                                } );
                            } }/>
                        </DLMenu>
                    </Table.Cell>
                </Table.Row>
            );
        } );

        return rows;
    }
}
FeaturedListsTable.defaultProps = {
    onListUpdated: ()=>{},
    onListDeleted: ()=>{},
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        showModal: ( modalName ) => {
            dispatch( showModal( modalName ) );
        },
        hideModal: ( modalName ) => {
            dispatch( hideModal( modalName ) );
        },
        updateList: ( listid, data ) => {
            return dAPI.patch( `/lists/${ listid }`, dAPI.clean.list( data ) );

        },
        deleteList: ( listid ) => {
            return dAPI.delete( `/lists/${ listid }` );

        },
        addTagToList: ( listid, newTag ) => {
            return dAPI.post( `/lists/${ listid }/tag`, { tag: newTag } );

        },
        deleteTagFromList: ( listid, tagtext ) => {
            return dAPI.delete( `/lists/${ listid }/tag/${ tagtext }` );

        },
    };
};

export default connect( null, mapDispatchToProps )( FeaturedListsTable );
